import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Box, Divider, IconButton, Tab, Tabs, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

import AvailabilityGrid from "./AvailabilityGrid";
import ReservationLedger from "./ReservationLedger";
import ESMMMapping from "./ESMMMapping";

// TODO: uncomment JITSellerPortal when backend is ready
// import JITSellerPortal from "./JITSellerPortal";

const TABS = [
  { label: "Availability Dashboard", component: <AvailabilityGrid /> },
  { label: "Derived Inventory", component: <ESMMMapping /> },
  { label: "Reservation Ledger", component: <ReservationLedger /> },
  // { label: "JIT Seller Portal", component: <JITSellerPortal /> },
];

const Availability = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState(0);
  const [visitedTabs, setVisitedTabs] = useState([0]);

  const handleTabChange = (_, v) => {
    setActiveTab(v);
    if (!visitedTabs.includes(v)) {
      setVisitedTabs((prev) => [...prev, v]);
    }
  };

  return (
    <Box>
      <Box display="flex" alignItems="flex-end" sx={{ mb: 3 }}>
        <IconButton size="small" onClick={() => navigate(-1)} sx={{ mr: 0.5 }}>
          <ArrowBackIcon />
        </IconButton>
        <Typography variant="h6" noWrap>
          Availability
        </Typography>
      </Box>

      <Box
        sx={{
          position: "sticky",
          top: 64,
          zIndex: 10,
          backgroundColor: theme.palette.background.default,
          pt: 1,
        }}
      >
        <Tabs
          value={activeTab}
          onChange={handleTabChange}
          variant="scrollable"
          scrollButtons="auto"
          sx={{
            "& .MuiTabs-indicator": {
              backgroundColor: theme.palette.accent.main,
              height: 4,
              borderRadius: "4px 4px 0 0",
            },
            minHeight: 48,
          }}
        >
          {TABS.map((tab, index) => (
            <Tab
              key={index}
              label={tab.label}
              sx={{
                textTransform: "none",
                minWidth: "auto",
                px: 3,
                fontWeight: 600,
                "&.Mui-selected": { color: theme.palette.accent.main },
                "&:hover": { color: theme.palette.accent.main, opacity: 1 },
              }}
            />
          ))}
        </Tabs>
        <Divider />
      </Box>

      <Box>
        {TABS.map((tab, index) => {
          if (!visitedTabs.includes(index)) return null;
          return (
            <Box
              key={index}
              sx={{ display: activeTab === index ? "block" : "none" }}
            >
              {tab.component}
            </Box>
          );
        })}
      </Box>
    </Box>
  );
};

export default Availability;